import classNames from 'classnames';
import PropTypes from 'prop-types';
import './style.scss';

export default function Checkbox(props) {
	const { id, checked, onClick, content, type, last, link, onLink, disabled, lightWeight } = props;
	return (
		<div className={classNames({ checkbox: true, 'checkbox--last': last })}>
			<input className='checkbox__box' id={id} type={type || 'checkbox'} checked={checked} disabled={disabled} onChange={onClick} />
			<span className={classNames({ checkbox__content: true, 'checkbox__content--light': lightWeight })}>{content}</span>
			{link && (
				<span className='hyperlink' onClick={onLink}>
					{link}
				</span>
			)}
		</div>
	);
}

Checkbox.propTypes = {
	id: PropTypes.string,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	onClick: PropTypes.any,
	content: PropTypes.string,
	link: PropTypes.string,
	onLink: PropTypes.any
};

Checkbox.defaultProps = {
	id: '',
	checked: false,
	onClick: '',
	content: '',
	link: '',
	onLink: '',
	disabled: false
};
